const awsconfig = {
    Auth: {
        Cognito: {
          userPoolClientId: '4oroinq30epp9aviglrt2m8jcu',
          userPoolId: 'us-east-1_z7gmmIrbx',
          identityPoolId: 'us-east-1:29151d3c-e77f-4fa8-8d02-38bc98cb891a',
          loginWith: {
            email: true,
            phone: false,
            username: false
          },
        },
      },
    Storage: {
        S3: {
          bucket: 'designxr-images',
          region: 'us-east-1'
        }
      }
  };
  
  export default awsconfig;
  